export interface UserRoleContext {
  isGlobalAdmin?: boolean
  isGlobalAuditor?: boolean
}

export enum UserRoles {
  GLOBAL_PILOT = 'global_pilote',
  LOCAL_PILOT = 'local_pilote',
  GLOBAL_AUDITOR = 'global_auditor',
  LOCAL_AUDITOR = 'local_auditor',
  CONTRIBUTOR = 'contributor',
  SUPPORT = 'support',
}

export enum ApiUserRoles {
  PILOT = 'global_rw',
  AUDITOR = 'global_ro',
  CONTRIBUTOR = 'local_usr',
  SUPPORT = 'support',
}

export const UserRolesByApiUserRole: Record<ApiUserRoles, UserRoles> = {
  [ApiUserRoles.PILOT]: UserRoles.GLOBAL_PILOT,
  [ApiUserRoles.AUDITOR]: UserRoles.GLOBAL_AUDITOR,
  [ApiUserRoles.CONTRIBUTOR]: UserRoles.CONTRIBUTOR,
  [ApiUserRoles.SUPPORT]: UserRoles.SUPPORT,
}
